import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import ErrorBoundary from '@fs/zion-error-boundary'
import Routes from './Routes'
import useCensusPermission from './hooks/useCensusPermission'
import useReportsAccess from './hooks/useReportsAccess'
import useAdminAccess from './hooks/useAdminAccess'
import AppTabs from './components/AppTabs'
import { VerifyPlacesProvider } from './providers/VerifyPlacesProvider'
import { FixBadCharactersProvider } from './providers/FixBadCharactersProvider'

function App(): JSX.Element {
  const labsFF = useFeatureFlag('give_labs')
  const sendBehaviorDataFF = useFeatureFlag('give_vp_send_behavior_data')
  const { hasCensusPermission } = useCensusPermission()
  const { authorized, error, loading } = useReportsAccess()
  const { data: adminPermissions, hasAccess: hasAdminAccess, loading: adminLoading } = useAdminAccess()

  const showReports = !loading && authorized && !error
  const showAdmin = !adminLoading && hasAdminAccess

  return (
    <ErrorBoundary>
      <AppTabs showReports={showReports} showAdmin={showAdmin} showLabs={labsFF.isOn} />
      <VerifyPlacesProvider sendBehaviorDataFF={sendBehaviorDataFF}>
        <FixBadCharactersProvider>
          <Routes
            hasCensusPermission={hasCensusPermission}
            hasAdminAccess={hasAdminAccess}
            adminLoading={adminLoading}
            adminPermissions={adminPermissions}
          />
        </FixBadCharactersProvider>
      </VerifyPlacesProvider>
    </ErrorBoundary>
  )
}

export default App
